import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Autocomplete,
    Tooltip,
    Grid,
    InputLabel,
    TextField,
    FormControl,
    InputBase,
    FormControlLabel,
    Checkbox,
    Divider,
    Typography,
    Chip,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled, alpha } from "@mui/material/styles";
import React, { useState, useEffect } from "react";
import { useStatePtr, useData } from "@pure-ptr/react";
import {
    Delete as DeleteIcon,
    CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
    CheckBox as CheckBoxIcon,
} from "@mui/icons-material";

import { useSelector } from "react-redux";
import { Formik } from "formik";
import { injectIntl } from "react-intl";
import { listTiny } from "../../../store/actions/users";
import { useDispatch } from "react-redux";
import { assignClaim,getValidUsers } from "../../../store/api/claimAssignment";
import { Loadable } from "../../../common";
import { list } from "../../../store/actions/users";
import { errorToastify } from "../../../util/toast";

const useStyles = makeStyles((theme) => ({
    button: {
        padding: "0.25rem",
    },
    formControlAuto: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        rowGap: "20px",
    },
    divider: {
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        marginBottom: "20px",
        padding: "15px 10px 15px 10px",
    },
}));

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
        marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
        borderRadius: 4,
        position: "relative",
        backgroundColor: "#F3F6F9",
        border: "1px solid",
        borderColor: "#E0E3E7",
        fontSize: 16,
        width: "100%",
        padding: "10px 12px",
        transition: theme.transitions.create([
            "border-color",
            "background-color",
            "box-shadow",
        ]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            boxShadow: `${alpha(
                theme.palette.primary.main,
                0.25
            )} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
        ...theme.applyStyles("dark", {
            backgroundColor: "#1A2027",
            borderColor: "#2D3843",
        }),
    },
}));

const ClaimAssignmentDialog = ({
    intl,
    openPtr,
    handleClose,
    selectedClaimsIds,
    callBack,
    defaultAssigned = undefined,
    dataUsers = [],
    needRefetch=true
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [claimAssignmentData, setClaimAssignmentData] = useState({});
    const clientId = useSelector(
        (state: any) => state?.dashboards?.selectedClient
    );

    const isSliced = useStatePtr(true);

    const {
        data: assignedClaimData,
        isPending,
        error,
    } = useData(async () => {
        if (Object.keys(claimAssignmentData).length === 0 ) return;
        const assignedClaimData = await assignClaim(claimAssignmentData);
        handleClose();
        if (callBack) {
            callBack();
        }
        return assignedClaimData;
    }, [claimAssignmentData]);

     const {
        data: usersInside,
    } = useData(async () => {
        if(needRefetch === false) return;
        const validUsers = await getValidUsers();
        return validUsers;
    }, []);


    useEffect(() => {
        dispatch(list());
    }, [list]);

    useEffect(() => {
        if (!error) return;
        errorToastify(
            error?.payload?.error ||
                "Something Went Wrong !! Please Contact Administrator"
        );
    }, [error]);

    const users = needRefetch ? usersInside : dataUsers;
    
    const sortByUsername = users => users?.sort((a, b) => (a.username || '').localeCompare(b.username || '', undefined, { sensitivity: 'base' }));

    return (
        <Dialog
            open={openPtr.value}
            onClose={handleClose}
            sx={{ "& .MuiPaper-root": { minWidth: "400px" } }}
        >
            <DialogTitle>Assign Claims</DialogTitle>
            {selectedClaimsIds?.length === 0 && (
                <>
                    <DialogContent>
                        <Typography>
                            No Claims Selected, Please select at least one claim
                            to assign.
                        </Typography>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleClose}> Close</Button>
                    </DialogActions>
                </>
            )}

            {selectedClaimsIds?.length > 0 && (
                <Loadable loading={isPending !== null}>
                    <Formik
                        enableReinitialize={true}
                        initialValues={{
                            assignedTo: defaultAssigned
                                ? [...(users || [])]?.find(
                                      (item) =>
                                          item?.username === defaultAssigned
                                  )
                                : null,
                            usernamesToNotify: [],
                            sendEmail: true,
                            followupDate: "",
                            comment: "",
                        }}
                        validate={(values) => {
                            const errors: any = {};

                            if (!values.assignedTo) {
                                errors.assignedTo = intl.formatMessage({
                                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                                });
                            }

                            if (values.comment.length > 200) {
                                errors.comment = "Max 200 Characters";
                            }

                            return errors;
                        }}
                        onSubmit={(values, {}) => {
                            const payload = {
                                ...values,
                                assignedTo: values?.assignedTo?.username,
                                sendEmail:values?.sendEmail,
                                usernamesToNotify:
                                    values?.usernamesToNotify?.map(
                                        (item) => item.username
                                    ),
                                analysisIds: [...selectedClaimsIds],
                            };
                            setClaimAssignmentData({ ...payload });
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,

                            handleSubmit,
                            setFieldValue,
                        }) => (
                            <form
                                onSubmit={handleSubmit}
                                noValidate
                                autoComplete="off"
                            >
                                <DialogContent dividers>
                                    <Grid container>
                                        <FormControl
                                            className={classes.formControlAuto}
                                        >
                                            <Autocomplete
                                                size="small"
                                                onChange={(e, option) =>
                                                    setFieldValue(
                                                        "assignedTo",
                                                        option
                                                    )
                                                }
                                                isOptionEqualToValue={(
                                                    option,
                                                    value
                                                ) => option?.username === value?.username}
                                                value={values.assignedTo}
                                                options={defaultAssigned ? [{name:"Unassigned",username:""},...(sortByUsername(users) || [])]:[...(sortByUsername(users) || [])]}
                                                getOptionLabel={(option) =>
                                                    option?.username || ""
                                                }
                                                renderInput={(params) => (
                                                    <TextField
                                                        variant="outlined"
                                                        {...params}
                                                        label="Username"
                                                        error={Boolean(
                                                            touched.assignedTo &&
                                                                errors.assignedTo
                                                        )}
                                                        helperText={
                                                            touched.assignedTo &&
                                                            errors.assignedTo
                                                        }
                                                    />
                                                )}
                                            />
                                           {defaultAssigned && <Button sx={{width:"fit-content"}} onClick={()=> setFieldValue(
                                                        "assignedTo",
                                                        {name:"Unassigned",username:""}
                                                    )}>Unassign Claim</Button>}

                                            <FormControl
                                                className={
                                                    classes.formControlAuto
                                                }
                                            >
                                                <Autocomplete
                                                    onChange={(e, value) =>
                                                        setFieldValue(
                                                            "usernamesToNotify",
                                                            value
                                                        )
                                                    }
                                                    //   filterOptions={filterOptions}
                                                    //   value={}
                                                    multiple
                                                    options={[...(users || [])]}
                                                    disableCloseOnSelect
                                                    getOptionLabel={(
                                                        option: any
                                                    ) => option?.username || ""}
                                                    renderOption={(
                                                        props,
                                                        option,
                                                        { selected }
                                                    ) => (
                                                        <li {...props}>
                                                            <Checkbox
                                                                icon={icon}
                                                                checkedIcon={
                                                                    checkedIcon
                                                                }
                                                                style={{
                                                                    marginRight: 8,
                                                                }}
                                                                checked={
                                                                    selected
                                                                }
                                                            />
                                                            {option?.username || ""}
                                                        </li>
                                                    )}
                                                    renderTags={(
                                                        tagValue,
                                                        getTagProps
                                                    ) => {
                                                        const numTags =
                                                            tagValue.length;
                                                        return (
                                                            <Typography variant="caption">
                                                                {(isSliced.value
                                                                    ? tagValue.slice(
                                                                          0,
                                                                          2
                                                                      )
                                                                    : tagValue
                                                                ).map(
                                                                    (
                                                                        option,
                                                                        index
                                                                    ) => (
                                                                        <Chip
                                                                            size="small"
                                                                            color="secondary"
                                                                            key={
                                                                                index
                                                                            }
                                                                            label={
                                                                                option.name
                                                                            }
                                                                            {...getTagProps(
                                                                                {
                                                                                    index,
                                                                                }
                                                                            )}
                                                                        />
                                                                    )
                                                                )}

                                                                {numTags >
                                                                    2 && (
                                                                    <Chip
                                                                        size="small"
                                                                        sx={{
                                                                            cursor: "pointer",
                                                                        }}
                                                                        onClick={() =>
                                                                            isSliced.set(
                                                                                !isSliced.value
                                                                            )
                                                                        }
                                                                        label={
                                                                            isSliced.value
                                                                                ? ` + ${
                                                                                      numTags -
                                                                                      2
                                                                                  }`
                                                                                : "See Less"
                                                                        }
                                                                    />
                                                                )}
                                                            </Typography>
                                                        );
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Notify by email"
                                                        />
                                                    )}
                                                />
                                            </FormControl>

                                            <FormControlLabel
                                                control={
                                                    <Checkbox defaultChecked 
                                                    
                                                    onChange={(e)=>setFieldValue("sendEmail",e.target.checked)}/>
                                                }
                                                label="Send Email"
                                            />

                                            <TextField
                                                sx={{ mt: "0" }}
                                                type="date"
                                                // disabled={!values.enabled || disableDateSection}
                                                label="Follow-Up Date"
                                                name="startdate"
                                                // className={classes.dateField}
                                                margin="normal"
                                                onChange={(e) =>
                                                    setFieldValue(
                                                        "followupDate",
                                                        e.target.value
                                                    )
                                                }
                                                value={values.followupDate}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <FormControl>
                                                <InputLabel
                                                    shrink
                                                    htmlFor="bootstrap-input"
                                                    sx={{
                                                        color:
                                                            Boolean(
                                                                touched.comment &&
                                                                    errors.comment
                                                            ) && "red",
                                                    }}
                                                >
                                                    Comments
                                                </InputLabel>
                                                <BootstrapInput
                                                    defaultValue="react-bootstrap"
                                                    onChange={(e) =>
                                                        setFieldValue(
                                                            "comment",
                                                            e.target.value
                                                        )
                                                    }
                                                    value={values.comment}
                                                    id="bootstrap-input"
                                                    error={Boolean(
                                                        touched.comment &&
                                                            errors.comment
                                                    )}
                                                />
                                                <Typography
                                                    color="error"
                                                    sx={{
                                                        fontWeight: "400",
                                                        fontSize: "10px",
                                                        p: "5px 0 0 10px",
                                                    }}
                                                >
                                                    {touched.comment &&
                                                        errors.comment}
                                                </Typography>
                                            </FormControl>
                                        </FormControl>
                                    </Grid>
                                </DialogContent>
                                {/* <Divider /> */}
                                <DialogActions className={classes.divider}>
                                    <Button
                                        type="button"
                                        onClick={handleClose}
                                        className="mr-3"
                                        variant="outlined"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                    >
                                        Assign
                                    </Button>
                                </DialogActions>
                            </form>
                        )}
                    </Formik>
                </Loadable>
            )}
        </Dialog>
    );
};

export default injectIntl(ClaimAssignmentDialog);
